import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import ScannerPage from "./ScannerPage";


const Auth = () => {

    const [isSubmitted, setIsSubmitted] = useState(false);
    useEffect(() => {
        SetSession()
    }, [])

    const SetSession = () => {
        let secret = localStorage.getItem("secret")
            // window.sessionStorage.getItem("secret");
        if (secret === "ffb1f3c7cd3d6e869bcd03250e6054f1d5403025") {
            setIsSubmitted(true)
        }
    }
    const GmailArray = [
        {
            id: 1,
            email: "haniye13720@gmail.com",
            password: "haniye123"
        },
        {
            id: 2,
            email: "erfanfakhar351@gmail.com",
            password: "erfan1234"
        },
        {
            id: 3,
            email: "famolazeinal@gmail.com",
            password: "zeinal123"
        },
        {
            id: 4,
            email: "Hamidreza.hpr72@gmail.com",
            password: "hamidreza"
        },
        {
            id: 5,
            email: "fae.hoda@gmail.com",
            password: "faeze1234"
        },
        {
            id: 6,
            email: "acemi.contentcreator@gmail.com",
            password: "content12"
        },
        {
            id: 7,
            email: "acemi.events@gmail.com",
            password: "events123"
        },
        {
            id: 8,
            email: "acemi.planner@gmail.com",
            password: "planner12"
        },
        {
            id: 9,
            email: "acemi.publicrelations@gmail.com",
            password: "public123"
        },
        {
            id: 9,
            email: "info@intcie.com",
            password: "info12345"
        }
    ];

    const handleSubmit = (event) => {
        event.preventDefault();
        let {email, pass} = document.forms[0];

        const userData = GmailArray.find((user) => user.email === email.value);

        if (userData) {
            if (userData.password !== pass.value) {
                toast("رمز عبور اشتباه است");
            } else {
                setIsSubmitted(true);
                localStorage.setItem("secret", "ffb1f3c7cd3d6e869bcd03250e6054f1d5403025")
                // window.sessionStorage.setItem("secret", "ffb1f3c7cd3d6e869bcd03250e6054f1d5403025");
                // sessionStorage.setItem("secret", "ffb1f3c7cd3d6e869bcd03250e6054f1d5403025");
            }
        } else {
            toast("برای ایمیل شما، دسترسی صادر نشده است.");
        }
    };

    const renderForm = (
        <div className="row">
            <div className="col-10 col-md-8 mrl-auto">
                <div className="form">
                    <h4 className="title-small text-right">ورود</h4>
                    <form onSubmit={handleSubmit}>
                        <div className="input-container">
                            <label>آدرس ایمیل</label>
                            <input type="email" name="email" required/>

                        </div>
                        <div className="input-container">
                            <label>رمز عبور </label>
                            <input type="password" name="pass" required/>

                        </div>
                        <div className="button-container">
                            <button className="my-btn" type="submit">
                                اسکن کنید
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
    return (
        <div className="container custom-margin-pt">
            <div className="text-center">
                <div className="app">
                    <div className="login-form">
                        {
                            isSubmitted
                                ?
                                <ScannerPage />
                                :
                                renderForm
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Auth